import React from 'react';
import { useSelector } from 'react-redux';
import { Row, Col} from 'react-bootstrap';

import { getCurrentCompanyButtons } from '../../helpers/companiesHelper';
import { getCurrentCompany } from '../../store/selectors';
import CompanyButton from './CompanyButton';

function CompanyButtons() {
  const currentCompany = useSelector(getCurrentCompany);
  const companyButtons = getCurrentCompanyButtons(currentCompany);
  const columns = 12/companyButtons.length;

  return (
    <>
      {
        Boolean(companyButtons.length) &&
        <Row className="mb-2">
          {companyButtons.map((companyBtn) => (
            <Col xs={6} sm={columns} className="mb-4" key={companyBtn.type}>
              <CompanyButton title={companyBtn.title} link={companyBtn.link} />
            </Col>
          ))}
        </Row>
      }
    </>
  );
}

export default CompanyButtons;
